import React from 'react';
import styled from '@emotion/styled';
import { Icon } from '@qga/roo-ui/components';

import useBreakpoints, { isScreen } from '@shared/v2/hooks/useBreakpoints';

import Travellers from '@/components/Travellers';
import { useSearchPanelControls } from '@/v2/components/pages/PackageView/contexts/SearchPanelControlsContext';
import { useSearchPanelData } from '@/v2/components/pages/PackageView/contexts/SearchPanelDataContext';

const StyledIcon = styled(Icon)`
  pointer-events: none;
  position: absolute;
  right: 10px;
`;

const StyledTravellers = styled(Travellers)`
  & > *:last-child {
    margin: 2px;
  }
`;

export type TravellersInputProps = {
  isMobileVariant?: boolean;
};

const TravellersInput = ({ isMobileVariant }: TravellersInputProps) => {
  // Screen size info
  const breakpoints = useBreakpoints();
  const isDesktopScreen = isScreen(breakpoints)('md', 'lg');

  // Modal/Dropdown Controls
  const { isTravellersOpen, openTravellers, closeTravellers } =
    useSearchPanelControls();
  const isOpen = isTravellersOpen && (isMobileVariant || isDesktopScreen); // Only open at mobile screens if mobile variant

  // Travellers Data
  const { travellers, isDisabled } = useSearchPanelData();
  const {
    value = { adults: 2, children: 0, infants: 0 },
    onChange = () => {},
  } = travellers || {};

  return (
    <StyledTravellers
      occupants={value}
      onSubmit={onChange}
      customBorderColor="colors.greys.alto"
      // @ts-expect-error this is a valid input that should be fixed when Travellers becomes TS
      icon={<StyledIcon name="user" />}
      isDisabled={isDisabled}
      isOpen={isOpen}
      onOpen={openTravellers}
      onClose={closeTravellers}
    />
  );
};

export default TravellersInput;
